module.exports = __webpack_public_path__ + "img/48h-plein-bleu.svg";